var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import Auth from '../model/User';
import _isEmpty from 'lodash/isEmpty';
import _trim from 'lodash/trim';
import querystring from 'querystring';
import tplusApi from './TplusApi';
import UIConfirm from '../components/UIConfirm';
import { clientId, clientSecret, tplusWebAppApiHost, ciaHost, cspAk, prodProxyHost, proxyServer } from '../const/app';
import User from '../model/User';
import { env } from 'mutants-microfx';
var constant = env.constant, platform = env.platform;
var QS = require('qs');
var LoginApi = /** @class */ (function () {
    function LoginApi() {
    }
    //用户登录验证 获取企业列表信息
    LoginApi.authentication = function (_a) {
        var username = _a.username, password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            var ajax, param, response, result, errorInfo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ajax = axios.create({
                            baseURL: ciaHost
                        });
                        param = {
                            'auth_username': username,
                            'password': password,
                            'needOrgLists': '1',
                            'client_id': clientId,
                            'client_secret': clientSecret,
                        };
                        return [4 /*yield*/, ajax.post('/internal_api/client_authentication_with_userInfo', querystring.stringify(param))];
                    case 1:
                        response = _b.sent();
                        result = response.data;
                        errorInfo = '';
                        if (result.auth_result == 'true') {
                            return [2 /*return*/, result];
                        }
                        else {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    //用户修改密码操作
    LoginApi.updatePwd = function (oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var user, access_token, appKey, passwordLevel, ajax, passwordInfo, param, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = User.restore();
                        access_token = user.accessToken;
                        appKey = atob(cspAk);
                        passwordLevel = 1;
                        ajax = axios.create({
                            baseURL: ciaHost
                        });
                        passwordInfo = JSON.stringify({
                            oldPassword: oldPassword,
                            newPassword: newPassword,
                            passwordLevel: passwordLevel
                        });
                        param = {
                            appKey: appKey,
                            access_token: access_token,
                            passwordInfo: passwordInfo
                        };
                        return [4 /*yield*/, ajax.post('/api/v1/user/password', querystring.stringify(param))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    LoginApi.authenticationByCode = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var ajax, param, response, d;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ajax = axios.create({
                            baseURL: ciaHost
                        });
                        if (!(platform === constant.platform.chanjet)) return [3 /*break*/, 2];
                        param = QS.stringify({
                            client_id: clientId,
                            client_secret: clientSecret,
                            auth_code: code
                        });
                        return [4 /*yield*/, ajax.post('/internal_api/codeForAccessTokenForClient', param)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(platform === constant.platform.yonyou)) return [3 /*break*/, 4];
                        param = QS.stringify({
                            client_id: clientId,
                            client_secret: clientSecret,
                            // appKey: atob(cspAk),
                            // appSecret: atob(cspAS),
                            code: code
                        });
                        return [4 /*yield*/, ajax.post('/special_api/v1/user/getTokenByYonyouCode', param)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4:
                        d = response.data;
                        if (d.hasOwnProperty('error') && d.hasOwnProperty('error_description') && !_isEmpty(_trim(d.error_description))) {
                            return [2 /*return*/, Promise.reject(d.error_description)];
                        }
                        else {
                            if (_isEmpty(_trim(d.user_id)) || _isEmpty(_trim(d.access_token))) {
                                return [2 /*return*/, Promise.reject('获取用户信息错误')];
                            }
                            else {
                                return [2 /*return*/, Promise.resolve(d)];
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    //获取云端的服务器地址
    LoginApi.getTargetURL = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ajax, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ajax = axios.create({
                            baseURL: tplusWebAppApiHost
                        });
                        return [4 /*yield*/, ajax.post('/serverUrl')];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    //获取云端的服务器地址
    LoginApi.getTargetURLByOrgID = function (targetOrgID) {
        return __awaiter(this, void 0, void 0, function () {
            var ajax, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ajax = axios.create({
                            baseURL: tplusWebAppApiHost
                        });
                        return [4 /*yield*/, ajax.post('/serverUrl', { targetOrgID: targetOrgID })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    //获取T+的token
    LoginApi.checkTplusToken = function (orgId, serverUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var checkThroughProxy, method, auth, clientName, desc, param, requestObj, user, ajax, url, user_req_id, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        checkThroughProxy = false;
                        if (serverUrl.indexOf(proxyServer) > -1) {
                            checkThroughProxy = true;
                        }
                        method = 'chanjet.EAP.GZQ.CSP.GetTPlusToken';
                        auth = Auth.restore();
                        clientName = window.localStorage.clientName || '';
                        desc = window.localStorage.desc || '';
                        //供循环调用时使用
                        if (!!clientName)
                            window.localStorage.clientName = clientName;
                        if (!!desc)
                            window.localStorage.desc = desc;
                        param = {
                            orgId: orgId,
                            cspUserId: auth.userId,
                            cspAppKey: atob(cspAk),
                            cspAppSecret: '',
                            lastLoginedToken: '',
                            clientName: clientName,
                            desc: desc,
                            NoLogout: true
                        };
                        requestObj = {};
                        requestObj = QS.stringify({
                            'Apis': JSON.stringify({
                                'Args': param,
                                'Method': method
                            })
                        });
                        user = User.restore();
                        ajax = axios.create({ baseURL: serverUrl });
                        url = 'api/rest';
                        url = url + '?IsFree=1&methodName=' + method + '&userId=' + user.userId + '&orgId=' + orgId;
                        user_req_id = user.userId + "x" + new Date().getTime().toString(16);
                        url += '&user_req_id=' + user_req_id;
                        return [4 /*yield*/, ajax.post(url, requestObj, { headers: { checkThroughProxy: checkThroughProxy, checkOrgId: orgId } })
                                .then(function (resp) {
                                return Promise.resolve(resp);
                            }).catch(function (err) {
                                UIConfirm.show("未找到云企业(orgid:90015044950)对应的账套，请重新选择企业登录", function () {
                                });
                                return Promise.reject(err);
                            })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    LoginApi.changeOrg = function (orgId) {
        return __awaiter(this, void 0, void 0, function () {
            var ajax, auth, user, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ajax = axios.create({
                            baseURL: tplusWebAppApiHost
                        });
                        auth = Auth.restore();
                        user = User.restore();
                        return [4 /*yield*/, ajax.post('gettplusauthinfo', QS.stringify({ orgId: orgId, ciaUserId: auth.userId, ciaToken: user.accessToken, targetOrgID: orgId }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    //获取云端的配置信息
    LoginApi.getApiConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.get(prodProxyHost + "?url=https://newretail-static-pro-bj.oss-cn-beijing.aliyuncs.com/fe_gateway/api_config.json")];
            });
        });
    };
    //获取T+的token
    LoginApi.getTplusToken = function (_a) {
        var _b = _a.clientName, clientName = _b === void 0 ? window.localStorage.clientName || '' : _b, _c = _a.desc, desc = _c === void 0 ? window.localStorage.desc || '' : _c;
        return __awaiter(this, void 0, void 0, function () {
            var method, auth, param, resp;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        method = 'chanjet.EAP.GZQ.CSP.GetTPlusToken';
                        auth = Auth.restore();
                        //供循环调用时使用
                        if (!!clientName)
                            window.localStorage.clientName = clientName;
                        if (!!desc)
                            window.localStorage.desc = desc;
                        param = {
                            orgId: auth.orgId,
                            cspUserId: auth.userId,
                            cspAppKey: atob(cspAk),
                            cspAppSecret: '',
                            lastLoginedToken: '',
                            clientName: clientName,
                            desc: desc
                        };
                        return [4 /*yield*/, tplusApi(param, method, false, true)];
                    case 1:
                        resp = (_d.sent());
                        return [2 /*return*/, resp];
                }
            });
        });
    };
    //获取jsTicket信息
    LoginApi.getSignature = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, access_token, param, query, url, ajax;
            return __generator(this, function (_a) {
                user = User.restore();
                access_token = user.accessToken;
                param = {
                    appKey: atob(cspAk),
                    access_token: access_token
                };
                query = QS.stringify(param);
                url = "/api/v1/thirdplatform/getSignature?" + query;
                ajax = axios.create({
                    baseURL: ciaHost
                });
                return [2 /*return*/, new Promise(function (res, rej) {
                        ajax.get(url).then(function (resp) {
                            var d = resp.data;
                            return res(d);
                        }).catch(function (err) {
                            return rej(err);
                        });
                    })];
            });
        });
    };
    //注销T+
    LoginApi.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var method, param, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        method = 'chanjet.Authorization.Logout';
                        param = {};
                        return [4 /*yield*/, tplusApi(param, method, false, false)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp];
                }
            });
        });
    };
    return LoginApi;
}());
export default LoginApi;

//# sourceMappingURL=LoginApi.js.map
